import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { JwtAuthService } from '../services/jwt-auth.service';
import { AuthService } from "@auth0/auth0-angular";
import { ContactSearchVM } from "../services/api";
import { AppStateService } from "../services/app-state.service";


@Injectable()
export class AdminGuard  {
  constructor(private router: Router,
    private auth:AuthService,
    private appState:AppStateService,
    private snack: MatSnackBar) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    var user:ContactSearchVM = this.appState.user;
    if (user && user.isAdmin) {
      return true;
    } else {
      //this.snack.open('You do not have access to this page!', 'OK');
      this.router.navigate(["/user/map"]);
      return false;
    }
  }
}
